import React from "react";
import FAQ from "../Components/FAQ/FAQ.jsx";

export default function FAQPage() {
  return <FAQ />;
}